import { render, staticRenderFns } from "./BisnisUnit.vue?vue&type=template&id=6f3421f4&"
import script from "./BisnisUnit.vue?vue&type=script&lang=js&"
export * from "./BisnisUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports